import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { assumeNonNull as t } from "./maybe.js";

var e = /*#__PURE__*/function () {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (t) {
      return t.values().next().value;
    };

    _classCallCheck(this, e);

    this._peeker = t, this._items = new Set();
  }

  _createClass(e, [{
    key: "length",
    get: function get() {
      return this._items.size;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._items.clear();
    }
  }, {
    key: "last",
    value: function last() {
      if (0 === this._items.size) return;
      var t;

      var _iterator = _createForOfIteratorHelper(this._items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          t = _step.value;
          ;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return t;
    }
  }, {
    key: "peek",
    value: function peek() {
      if (0 !== this._items.size) return this._peeker(this._items);
    }
  }, {
    key: "push",
    value: function push(t) {
      this.contains(t) || this._items.add(t);
    }
  }, {
    key: "contains",
    value: function contains(t) {
      return this._items.has(t);
    }
  }, {
    key: "pop",
    value: function pop() {
      if (0 === this.length) return;

      var _e = this.peek();

      return this._items.delete(t(_e)), _e;
    }
  }, {
    key: "popLast",
    value: function popLast() {
      if (0 === this.length) return;

      var _e2 = this.last();

      return this._items.delete(t(_e2)), _e2;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      this._items.delete(t);
    }
  }, {
    key: "filter",
    value: function filter(t) {
      var _this = this;

      return this._items.forEach(function (_e3) {
        t(_e3) || _this._items.delete(_e3);
      }), this;
    }
  }]);

  return e;
}();

export { e as default };